import { useCardsRouterContext } from '@apps/card/Card.routes';
import { getDimensions, getOrientation } from '@apps/card/utils';
import { ChoiceGroup, useCustomizationContext } from '@apps/card/routes/CardCustomizer';
import type { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { useStationeryTemplatesBySizeQuery } from '@graphql/generated';
import React from 'react';
import { useTranslation } from '@shared/core';

export function useTemplatesBySize(category: StationeryTemplateCategoryEnum, themeId: string) {
  const { data } = useStationeryTemplatesBySizeQuery({
    variables: {
      filter: {
        categories: [category],
        enabled: true,
        side: 'front',
        themeIds: [themeId],
      },
    },
    batchMode: 'fast',
  });

  const templates = data?.stationeryTemplatesContainer.pagedResults.edges.map(edge => edge.node) ?? [];
  templates.sort((a, b) => {
    if (a.widthInches === b.widthInches) {
      return a.heightInches - b.heightInches;
    }
    return a.widthInches - b.widthInches;
  });

  return templates;
}

export const OrientationChoiceGroup = (props: { templateId: string }) => {
  const { templateId } = props;
  const { tq } = useTranslation('stationery');
  const [draft] = useCustomizationContext(draft => draft);
  const dimensions = getDimensions(draft.config.card);

  const templates = useTemplatesBySize(draft.stationeryTemplateCategory, draft.template.themeId).filter(t => {
    // prettier-ignore
    return t.widthInches === dimensions.width && t.heightInches === dimensions.height
		|| t.heightInches === dimensions.width && t.widthInches === dimensions.height;
  });

  const { goToProductDetailsPage } = useCardsRouterContext();

  // Don't even show the group header "Orientation: Portrait"
  if (templates.length <= 1) return null;

  return (
    <ChoiceGroup
      title={tq`Orientation`}
      value={templateId}
      setValue={nextTemplateId => {
        goToProductDetailsPage('wedding', draft.stationeryTemplateCategory, draft.template.themeId, nextTemplateId, 'replace');
      }}
      choices={templates.map(t => t.id)}
      getName={(id: string) => {
        const { widthInches, heightInches } = templates.find(t => t.id === id)!;
        return getOrientation(widthInches, heightInches);
      }}
      minHeight={55}
    />
  );
};
